module.exports = __webpack_public_path__ + "img/co_branded.ce1cedeb.png";